'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _redux = require('redux');

var _product_type = require('../actions/product_type');

var INITIAL_STATE = {
    isFetching: false,
    didInvalidate: false,
    items: []
};
var productTypes = function productTypes() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
    var action = arguments[1];

    switch (action.type) {
        case _product_type.INVALIDATE_PRODUCT_TYPES:
            return _extends({}, state, {
                didInvalidate: true
            });
        case _product_type.REQUEST_PRODUCT_TYPES:
            return _extends({}, state, {
                isFetching: true,
                didInvalidate: false
            });
        case _product_type.RECEIVE_PRODUCT_TYPES:
            return _extends({}, state, {
                isFetching: false,
                didInvalidate: false,
                items: action.productTypes
            });
        case _product_type.FAILURE_PRODUCT_TYPES:
            return _extends({}, state, {
                isFetching: false,
                error: action.error
            });
        default:
            return state;
    }
};

var productTypeReducer = (0, _redux.combineReducers)({
    productTypes: productTypes
});

exports.default = productTypeReducer;


//////////////////
// WEBPACK FOOTER
// ./src/js/reducers/product_type.js
// module id = 877
// module chunks = 0